export default function newsCarouselDirective() {
  return {
    template: require('./news-carousel.html'),
    controller: 'NewsCarouselController',
    controllerAs: 'newsCarouselVM',
    bindToController: true,
    replace: true,
  };
}
